import { Component, Input, OnInit } from '@angular/core';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { PickupType, SendMoneyDetail } from '../../models/sendmoney/sendmoney';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { CountryService } from '../../sharedcomponents/commonservice/countrylist.service';
import { PaymentType } from '../../sharedcomponents/_common/constants/app.constants';
import { SendMoneyService } from '../../_services/sendmoneyservice/sendmoneyservice';
import { utilityService } from 'app/sharedcomponents/commonservice/utility.service';
import { overlayConfigFactory } from 'angular2-modal';
import { ErrorPopupComponent } from '../../sharedcomponents/_directive/error-popup/error-popup.component';

@Component({
  selector: 'app-summary-detail',
  templateUrl: './summary-detail.component.html',
  styleUrls: ['./summary-detail.component.css'],
  providers: [AlertService, Modal, CountryService]
})
export class SummaryDetailComponent implements OnInit {
  @Input() taxes: any = 0;
  @Input() taxesDetail: any;  
  sendMoneyDetail: SendMoneyDetail;
  summaryDetailData: any = {};
  payerCollection: any;
  countrycollection: any;
  stateCollection: any;
  cityCollection: any;
  BranchDetails: any;
  countryName: string;
  paymentType: any;
  isShow: boolean = true;
  PageFlow: any = {}; 
  constructor(private sendMoneyService: SendMoneyService, public utilService: utilityService, public translate: TranslateService, private modal: Modal,) {
    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    });
    this.paymentType = PaymentType;
    // const t = this.sendMoneyDetail.paymentDetails.exchangeRate;
    this.isShow = this.sendMoneyDetail.paymentDetails.destCurrCode == '' ? false : true;
    this.PageFlow.Value = sessionStorage.PageFlow;
  }

  ngOnInit() {}

  getPaymentType(type) {
    let val;
    switch (parseInt(type, 0)) {
      case PaymentType.DebitCard: {
        val = this.translate.instant('Common_lblDebitCard'); // "Debit Card";
        break;
      }
      case PaymentType.PayAtStore: {
        val = this.translate.instant('Common_lblPayStore'); // "Pay At Store";
        break;
      }
    }
    return val;
  }

  openTaxesDetail() {
    console.log("Hola m")
    let modalData: any = {};
    modalData.Title = this.translate.instant('Common_lblTaxDetails');
    modalData.Message = "";

    if (this.sendMoneyDetail.branchDetails.TaxDetails == null || this.sendMoneyDetail.branchDetails.TaxDetails.length === 0) {
        modalData.Message = this.translate.instant('Common_lblNoTax'); 
    } else {
        // Mapear cada elemento del array a una cadena con el formato "Name: $Amount"
        const taxMessages = this.sendMoneyDetail.branchDetails.TaxDetails.map(tax => {
            return `${tax.Name}: $${tax.Amount.toFixed(2)}`; // toFixed(2) para mostrar 2 decimales
        });
        
        // Unir todos los mensajes con <br> como separador
        modalData.Message = taxMessages.join('<br>');
    }
    this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }

  // loadPickupTypeText(type) {
  //   let classVal;
  //   switch (parseInt(type, 0)) {
  //     case PickupType.atmDeposit: {
  //       classVal = this.translate.instant('PickupTypeLabels_lblAtmDeposit');
  //       break;
  //     }
  //     case PickupType.bankDeposit: {
  //       classVal = this.translate.instant('PickupTypeLabels_lblBankDeposit');
  //       break;
  //     }
  //     case PickupType.homeDelivery: {
  //       classVal = this.translate.instant('PickupTypeLabels_lblHomeDelivery');
  //       break;
  //     }
  //     case PickupType.officePickup: {
  //       classVal = this.translate.instant('PickupTypeLabels_lblOfficePickup');
  //       break;
  //     }
  //   }

  //   return classVal;
  // }

  // loadPickupType(type) {
  //   let classVal;
  //   switch (parseInt(type, 0)) {
  //     case PickupType.atmDeposit: {
  //       classVal = 'atm_deposit_btn pickup_default';
  //       break;
  //     }
  //     case PickupType.bankDeposit: {
  //       classVal = 'bank_deposit_btn pickup_default';
  //       break;
  //     }
  //     case PickupType.homeDelivery: {
  //       classVal = 'home_delivery_btn pickup_default';
  //       break;
  //     }
  //     case PickupType.officePickup: {
  //       classVal = 'office_btn pickup_default';
  //       break;
  //     }
  //   }
  //   return classVal;
  // }
  getCardNumber() {
    if (this.sendMoneyDetail.paymentDetails.paymentType == this.paymentType.DebitCard && this.sendMoneyDetail.cardDetails.cardlastfournum != '') {
      return ' XXXX-XXXX-XXXX-' + this.sendMoneyDetail.cardDetails.cardlastfournum;
    }
  }
  getAccountNumber() {
    if (this.PageFlow.Value == 'repeatorder') {
      let str = this.sendMoneyDetail.bankAccountDetails.BankAccountNumber.toString();
      return ' XXXX-XXXX-XXXX-' + str.substring(str.length - 4);
    } else {
      return this.sendMoneyDetail.bankAccountDetails.BankAccountNumber;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/_summary-detail/summary-detail.component.ts